import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { Provider } from 'react-redux';
import store from './store';
import axios from 'axios';
// STORE -> GLOBALIZED STATE
// ACTION - INCREMENT
// REDUCER MODIFIES STORE BASED ON THE ACTIONS
// DISPATCH -> SENDS ACTION TO THE REDUCER
axios.defaults.baseURL = "https://i2talk.live/api/"
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
